import { combineReducers } from 'redux';
import cartItemReducer from './CartItem/cartItemReducer';
import productItemReducer from './ProductItem/productItemReducer';

const rootReducer = combineReducers({
  productItems: productItemReducer,
  cartItems: cartItemReducer,
});

export default rootReducer;
